























































import CreateDialog from '@/components/CreateDialog.vue'
import { editMixin } from '@/utils/mixins/editMixin'
import { Product } from '@/utils/interfaces/topup.interface'
import { number } from '@/utils/validators'
import { VueForm } from '@/utils/interfaces'
import { createOrUpdateProduct } from '@/api/Topup/topup.api'
import { productsCode } from '@/utils/productsCode.constant'
import vRules from '~/utils/vRules'

export default editMixin.extend({
  components: {
    appCreateDialog: CreateDialog,
  },
  props: {
    value: Boolean,
  },
  data() {
    return {
      defaultCrud: {
        amount: 0,
        name: '',
        validation_regex: '',
        code: '',
        destination_amount: '',
        best_seller: false,
        best_seller_message: '',
      },
      rules: {
        numeric: (value: string) =>
          number(value) || this.$t('validation.must-be-a-number'),
        greaterThan: (value: number) =>
          value > 0 ||
          this.$t('validation.must-be-greater-than-equal', { value: 0 }),
        required: vRules.required,
      },
      crud: {} as Product,
      loading: false,
      codeItems: productsCode,
    }
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      try {
        this.loading = true
        const response = await createOrUpdateProduct(this.crud)
        this.$emit('new-item', response.data)
        this.$emit('input', false)
      } finally {
        this.loading = false
      }
    },
  },
})
